import { render, staticRenderFns } from "./sortPopover.vue?vue&type=template&id=e22578c0&scoped=true"
import script from "./sortPopover.vue?vue&type=script&lang=js"
export * from "./sortPopover.vue?vue&type=script&lang=js"
import style0 from "./sortPopover.vue?vue&type=style&index=0&id=e22578c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e22578c0",
  null
  
)

export default component.exports